import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { BankingDataService } from '../banking-data.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

import { BankingDataDetails } from './banking-data-details.model';

@Component({
  selector: 'itpx-banking-data-details',
  templateUrl: './banking-data-details.component.html',
  styleUrls: ['./banking-data-details.component.css']
})
export class BankingDataDetailsComponent implements OnInit {

    private details: BankingDataDetails;
    private sub: Subscription;
    private id: string;
    private isInProgress: boolean = false;

    private fields: Array<any>;
    private buttons: Array<any> = [
        {
            title: 'Edit',
            action: 'edit',
            icon: 'fa-pencil-square',
            class: 'btn-primary',
            disabled: false
        },
        {
            title: 'Delete',
            action: 'delete',
            icon: 'fa-trash',
            class: 'btn-danger',
            disabled: false
        }
    ];

    constructor(
        private bankingDataService: BankingDataService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        this.details = new BankingDataDetails();

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.bankingDataService.getBankingDataDetails(this.id)
                            .subscribe(
                                data => this.extractData(data)
                            );
        });

        this.fields = this.bankingDataService.getDetailsFields();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(body: any) {
        this.details = <BankingDataDetails>body.data;
    }

    private onAction(action: string) {
        this.isInProgress = true;
        if (action == 'edit') {
            this.router.navigate(['/agora/account-data/banking-data/:id/edit', { id: this.id }]);
        } else if (action == 'delete') {
            this.bankingDataService.delete(this.details)
                        .subscribe(
                            data => {
                                this.isInProgress = false;
                                this.notificationService.success(
                                    'Successfully deleted Banking Data',
                                    'Success'
                                );
                                this.router.navigate(['/agora/account-data/accounts']);
                            },
                            error => this.isInProgress = false
                        );
        } else {
            return false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/banking-data/details/banking-data-details.component.ts